"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = environment;
exports.create = create;
exports.on = on;

var _hash = _interopRequireDefault(require("./hash"));

var _get = _interopRequireDefault(require("../get"));

var _set = _interopRequireDefault(require("../set"));

var _verify = _interopRequireDefault(require("../verify"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function environment(environments, initial, assign, setup, fn) {
  assign = initial === assign ? initial : Object.assign({}, initial, assign);
  const keys = Object.keys(setup);
  const envs = keys.reduce((acc, key) => {
    const value = setup[key];
    const map = typeof value === 'object' && value.map ? value.map : x => x;
    const env = map(assign[key]); // eslint-disable-next-line eqeqeq

    acc[key] = env == undefined ? 'default' : env;
    return acc;
  }, {});
  const id = (0, _hash.default)(envs);

  if (!environments.hasOwnProperty(id)) {
    create(id, envs, environments, initial, setup, fn);
  }

  return environments[id];
}

function create(id, envs, environments, initial, setup, fn) {
  const configObj = fn(envs, on(envs));
  (0, _verify.default)(configObj);
  environments[id] = Object.assign({}, configObj, {
    get(path) {
      return (0, _get.default)(this, path);
    },

    set(path, value) {
      return (0, _set.default)(this, path, value);
    },

    pure() {
      const o = Object.assign({}, this);
      delete o.get;
      delete o.set;
      delete o.pure;
      delete o.environment;
      return o;
    },

    environment(assign) {
      return environment(environments, initial, assign || initial, setup, fn);
    }

  });
}

function on(envs) {
  return Object.entries(envs).reduce((acc, [key, value]) => {
    acc[key] = function on(obj) {
      if (!obj.hasOwnProperty(value)) return obj.default;

      if (typeof obj[value] === 'object' && !Array.isArray(obj[value])) {
        return _objectSpread({}, obj.default, obj[value]);
      }

      return obj[value];
    };

    return acc;
  }, {});
}